import React, { useState } from 'react';
import { useCredit, useEligibility } from 'hooks';
import CircularProgress from '@mui/material/CircularProgress';
import { Tab, Tabs } from '@mui/material';
import { CreditResultsList, AffordabilityResults, ResultAccordions, SearchInput, TabPanel } from 'components';

function a11yProps(index: number) {
  return {
    id: `strideup-tab-${index}`,
    'aria-controls': `strideup-tabpanel-${index}`,
  };
}

export const DashboardPage = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { results: eligibilities, fetchEligibility } = useEligibility();
  const { results: credits, fetchCreditsDetails } = useCredit();

  const [activeTab, setActiveTab] = React.useState(1);

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const handleSearchEligibility = async (id: string) => {
    setIsLoading(true);
    await fetchEligibility(id);
    await fetchCreditsDetails(id);
    setIsLoading(false);
  };

  return (
    <div className={'mt-8 w-full px-4'}>
      <SearchInput onSearchResult={handleSearchEligibility} placeholder='Search Application' loading={isLoading} />
      <div className={'mt-8 flex flex-col items-center'}>
        {isLoading ? (
          <div className={'flex'}>
            <CircularProgress />
          </div>
        ) : (
          <div className={'w-full'}>
            <Tabs className={'w-full'} value={activeTab} onChange={handleChangeTab} aria-label='tabs'>
              <Tab label='Application' {...a11yProps(0)} />
              <Tab label='Eligibility' {...a11yProps(1)} />
              <Tab label='Credit' {...a11yProps(2)} />
              <Tab label='Affordability' {...a11yProps(3)} />
            </Tabs>
            <TabPanel value={activeTab} index={0} />
            <TabPanel value={activeTab} index={1}>
              {!isLoading && eligibilities.length > 0 && <ResultAccordions items={eligibilities} />}
            </TabPanel>
            <TabPanel value={activeTab} index={2}>
              {!isLoading && credits.length > 0 && <CreditResultsList results={credits} />}
            </TabPanel>
            <TabPanel value={activeTab} index={3}>
              <AffordabilityResults />
            </TabPanel>
          </div>
        )}
      </div>
    </div>
  );
};
